import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { extractError } from '@/helpers/extractApiError';
import HubspotInfoService from '@/services/SettingsServices/HubspotInfoService';

const model = {
    data: null,
    submitting: false,
    errors: null,
    successOnCreate: '',
    loading: false,
};

export const getHubspotInfo = createAsyncThunk(
    'hubspot/getHubspotInfo',
    async (_, { rejectWithValue }) => {
        try {
            const response = await HubspotInfoService.getHubspotInfo();
            return response.data;
        } catch (error) {
            return rejectWithValue(extractError(error));
        }
    },
);

export const addHubspotInfo = createAsyncThunk(
    'hubspot/addHubspotInfo',
    async (data, { rejectWithValue }) => {
        const { checkbox_included: checkboxIncluded } = data;
        let response;
        try {
            if (!checkboxIncluded) {
                response = await HubspotInfoService.addHubspotInfo(data);
            } else {
                response = await HubspotInfoService.syncObjectsWithHubspot(data);
            }
            return response;
        } catch (error) {
            return rejectWithValue(extractError(error));
        }
    },
);

const hubspotInfoSlice = createSlice({
    name: 'hubspotInfo',
    initialState: model,
    reducers: {
        resetHubspotInfoStateOnError: (state) => {
            state.errors = null;
        },
        resetHubspotInfoStateOnSuccess: (state) => {
            state.successOnCreate = '';
        },
    },
    extraReducers: (builder) => {
        // get hubspot info config
        builder.addCase(getHubspotInfo.pending, (state) => {
            state.loading = true;
        }).addCase(getHubspotInfo.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        }).addCase(getHubspotInfo.rejected, (state) => {
            state.loading = false;
        });

        // add hubspot info config
        builder.addCase(addHubspotInfo.pending, (state) => {
            state.submitting = true;
        }).addCase(addHubspotInfo.fulfilled, (state, action) => {
            state.submitting = false;
            state.successOnCreate = action.payload.message;
        }).addCase(addHubspotInfo.rejected, (state, action) => {
            state.submitting = false;
            state.errors = action.payload;
        });
    },
});

export const {
    resetHubspotInfoStateOnError,
    resetHubspotInfoStateOnSuccess,
} = hubspotInfoSlice.actions;

export default hubspotInfoSlice.reducer;
